"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const mf_app_1 = require("@4r/mf-app");
const mf_contracts_4services_1 = require("@4r/mf-contracts-4services");
const react_1 = require("react");
function useOfflineCommand() {
    const [isCommandPending, setIsCommandPending] = (0, react_1.useState)(false);
    function submitCommand(command, postSubmit) {
        return __awaiter(this, void 0, void 0, function* () {
            let commandResult;
            try {
                setIsCommandPending(true);
                commandResult = yield (0, mf_app_1.getService)(mf_contracts_4services_1.ServiceNames.Command).submitCommand(command);
                if (postSubmit) {
                    const promise = postSubmit(commandResult);
                    if (promise)
                        yield promise;
                }
                return commandResult;
            }
            finally {
                setIsCommandPending(false);
            }
        });
    }
    return [isCommandPending, submitCommand];
}
exports.default = useOfflineCommand;
